// extracted by mini-css-extract-plugin
export default {"main":"MobileView_main__OgmFt","main_two":"MobileView_main_two__x9Iah"};